import React from 'react'

export default function UpOutlinedArrow(props) {
  return (
    <svg
      width={props.width ? props.width : '24'}
      height={props.height ? props.height : '24'}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M19.0019 13.9982C19.0024 14.2319 18.921 14.4583 18.7719 14.6382C18.6879 14.7395 18.5848 14.8232 18.4685 14.8846C18.3521 14.9459 18.2248 14.9837 18.0939 14.9958C17.9629 15.0079 17.8308 14.994 17.7052 14.9549C17.5796 14.9159 17.4629 14.8524 17.3619 14.7682L12.0019 10.2882L6.63189 14.6082C6.52961 14.6913 6.41191 14.7533 6.28557 14.7908C6.15923 14.8282 6.02674 14.8403 5.89571 14.8264C5.76468 14.8124 5.6377 14.7727 5.52206 14.7095C5.40643 14.6464 5.30442 14.561 5.22189 14.4582C5.13086 14.3548 5.06219 14.2336 5.0202 14.1023C4.97821 13.9711 4.96381 13.8326 4.97789 13.6955C4.99198 13.5584 5.03425 13.4257 5.10205 13.3057C5.16985 13.1857 5.26172 13.081 5.37189 12.9982L11.3719 8.16824C11.5508 8.02116 11.7753 7.94075 12.0069 7.94075C12.2385 7.94075 12.463 8.02116 12.6419 8.16824L18.6419 13.1682C18.7629 13.2686 18.8586 13.396 18.9211 13.5402C18.9837 13.6844 19.0113 13.8413 19.0019 13.9982Z'
        fill={props.color ? props.color : '#1D79FB'}
      />
    </svg>
  )
}
